<script>
import {
  RectangleStencil,
} from 'vue-advanced-cropper';

export default {
  name: 'HexagonStencil',
  extends: RectangleStencil,
  methods: {
    aspectRatios() {
      const max = 1000;
      return {
        minimum: 1 / max,
        maximum: max,
      };
    },
    // For external use
    processCrop(canvas) {
      // Receives square crop. Returns rounded crop.
      const context = canvas.getContext('2d');
      const { width } = canvas;
      const { height } = canvas;
      context.globalCompositeOperation = 'destination-in';
      context.beginPath();
      context.scale(1, height / width);

      context.moveTo(0, width / 2);
      context.lineTo(width / 4, 0);
      context.lineTo((width * 3) / 4, 0);
      context.lineTo(width, width / 2);
      context.lineTo((width * 3) / 4, width);
      context.lineTo(width / 4, width);
      context.lineTo(0, width / 2);

      context.closePath();
      context.fill();
      return canvas;
    },
  },
};
</script>
<style lang="scss" scoped>
.vue-rectangle-stencil {
  ::v-deep &__preview {
    clip-path: polygon(0% 50%, 25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  }
}
</style>
